export default __webpack_public_path__ + "static/media/Footpad's Straps of the Hidden Palace.ec7dd438.jpg";